/**
 * Revolut Environment
 * Flutter source: lib/domain/enums/revolut_environment.dart
 *
 * String values must match Flutter's `RevolutEnvironment.<name>.name`
 * verbatim, since the cloud function reads `data.environment` as-is.
 */
export enum RevolutEnvironment {
  sandbox = 'sandbox',
  production = 'production',
}
